<template>
    <div class="case-study-video  px-10">
        <video autoplay="autoplay" muted="muted" loop="loop" controls class="block mx-auto max-w-full">
            <source :src="video.url" type="video/mp4">
        </video>
    </div>
</template>

<script>
    export default {
        name : 'case-study-video',

        props : {
            block : {
                type : Object,
                default : () => {}
            }
        },

        computed : {
            video(){
                return this.block.video[0];
            }
        }
    }
</script>